import { render, staticRenderFns } from "./SimulatorFormCard.vue?vue&type=template&id=dcf95cc2&"
import script from "./SimulatorFormCard.vue?vue&type=script&lang=ts&"
export * from "./SimulatorFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports